// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-description {
  width: 300px;
  height: 36px;
  margin-top: 90px;
  margin-bottom: 14px;
}
.modal-description p {
  font-size: 16px;
  text-align: center;
  letter-spacing: 0px;
  color: #3B3B3B;
  opacity: 1;
}

.modal-content {
  width: 450px !important;
  height: 300px !important;
}

.btn-yes {
  background: var(--unnamed-color-2c906b) 0% 0% no-repeat padding-box;
  background: #2C906B 0% 0% no-repeat padding-box;
  border-radius: 10px;
  border: none !important;
  opacity: 1;
  margin-right: 10px;
  text-align: center;
  letter-spacing: 0px;
  color: #EFF7F5;
  width: 120px;
  height: 38px;
  outline: none;
}

.btn-no {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #A0D7C7;
  border-radius: 10px;
  opacity: 1;
  text-align: center;
  letter-spacing: 0px;
  color: #2C906B;
  width: 120px;
  height: 38px;
  outline: none;
}

.modal-options {
  text-align: center;
  margin-bottom: 90px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modals/confirm/confirm.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AAAI;EAEI,eAAA;EAEA,kBAAA;EAEA,mBAAA;EACA,cAAA;EACA,UAAA;AADR;;AAKA;EACI,uBAAA;EACA,wBAAA;AAFJ;;AAKA;EACI,mEAAA;EACA,+CAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EAGA,kBAAA;EAEA,mBAAA;EACA,cAAA;EAEA,YAAA;EACA,YAAA;EACA,aAAA;AANJ;;AASA;EAGI,+CAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EAGA,kBAAA;EAEA,mBAAA;EACA,cAAA;EAEA,YAAA;EACA,YAAA;EACA,aAAA;AAZJ;;AAeA;EACI,kBAAA;EACA,mBAAA;AAZJ","sourcesContent":[".modal-description {\n    width: 300px;\n    height: 36px;\n    margin-top: 90px;\n    margin-bottom: 14px;\n    p{\n        // font: normal normal normal 16px/18px Helvetica Neue,sans-serif;\n        font-size: 16px;\n        // color: var(--unnamed-color-3b3b3b);\n        text-align: center;\n        \n        letter-spacing: 0px;\n        color: #3B3B3B;\n        opacity: 1;\n    }  \n}\n\n.modal-content{ \n    width: 450px !important;\n    height: 300px !important;\n}\n\n.btn-yes{\n    background: var(--unnamed-color-2c906b) 0% 0% no-repeat padding-box;\n    background: #2C906B 0% 0% no-repeat padding-box;\n    border-radius: 10px;\n    border: none !important;\n    opacity: 1;\n    margin-right: 10px;\n\n    // color: var(--unnamed-color-eff7f5);\n    text-align: center;\n    // font: normal normal normal 16px/18px Helvetica Neue,sans-serif;\n    letter-spacing: 0px;\n    color: #EFF7F5;\n\n    width: 120px;\n    height: 38px;\n    outline: none;\n}\n\n.btn-no{\n    // background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;\n    //border: 1px solid var(--unnamed-color-a0d7c7);\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    border: 1px solid #A0D7C7;\n    border-radius: 10px;\n    opacity: 1;\n\n    // color: var(--unnamed-color-2c906b);\n    text-align: center;\n    // font: normal normal normal 16px/18px Helvetica Neue,sans-serif;\n    letter-spacing: 0px;\n    color: #2C906B;\n\n    width: 120px;\n    height: 38px;\n    outline: none;\n}\n\n.modal-options{\n    text-align: center;\n    margin-bottom: 90px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
